import { useEffect } from 'react';
import { useSignUpContext } from '../SignUp.context';
import { UseRegisterStepSubmitParams } from './useRegisterStepSubmit.types';

const useRegisterStepSubmit = ({
  submit,
  isSubmitting,
  isActive = true,
}: UseRegisterStepSubmitParams) => {
  const { registerStepSubmit, setStepSubmitting } = useSignUpContext();

  useEffect(() => {
    if (!isActive) {
      return;
    }
    registerStepSubmit(submit);
    return () => registerStepSubmit(null);
  }, [registerStepSubmit, submit, isActive]);

  useEffect(() => {
    if (!isActive) {
      return;
    }
    setStepSubmitting(isSubmitting);
  }, [setStepSubmitting, isSubmitting, isActive]);
};

export default useRegisterStepSubmit;
